import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const TransferOnline2Style = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
    //transform:"translateZ(0) !important"//menis
    //transform: "translate3d(0,0,0)"
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  TransferOnline2_viewStepsInfo_lbl_lbl1: {
    marginTop        : 30,
    marginBottom     : 10,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  TransferOnline2_viewStepsInfo_lbl_lbl2: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#35B6B4",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  logo: {
    margin: "1rem 0",
    "& img": {
      width: "25%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  label1: {
    fontSize     : "1rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "300",
    color        : "#303030",
    textAlign    : "left",
    "vertical-align":"middle",
  },
  textField1: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },
  textField2: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },
  textField3: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },
  textField4: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" }
  },

  textField10: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField11: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField12: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField13: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField14: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField15: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField16: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField17: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField18: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField19: { marginTop:10, marginBottom:10, input:{ color : "303030" } },

  D2BInfoText_lbl1: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  D2BInfoText_lbl2: {
    marginTop        : 10,
    marginBottom     : 5,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  D2BInfoText_lbl3: {
    marginTop        : 0,
    marginBottom     : 10,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  //--------
  //DropDown
  //--------
  picker1_textFieldLabel1: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  picker1b_textFieldLabel1: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  picker1c_textFieldLabel1: {
    marginTop        : 10,
    marginBottom     : 10,
  },
  picker2_textFieldLabel1: {
    marginTop        : 10,
    marginBottom     : 10,
  },

  picker10_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker11_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker12_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker13_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker14_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker15_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker16_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker17_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker18_textFieldLabel1: { marginTop:10, marginBottom:10 },
  picker19_textFieldLabel1: { marginTop:10, marginBottom:10 },
  //-------
  //Buttons
  //-------
  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 50,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
    "&:focus"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
  },
  backButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 0,
    marginBottom     : 20,
    color            : "#0000ff",
    backgroundColor  : "rgba(255, 255, 255, 1.0)",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
    "&:focus"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
  //------------
  //viewSteps3/4
  //------------
  viewSteps3Image: {
    margin: "0rem 0",
    "& img": {
      width: "75%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  viewSteps4Image: {
    margin: "0rem 0",
    "& img": {
      width: "75%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  viewSteps4ImageDots: {
    "& img": {
      width: "200%",
      display: "block",
      margin: "auto"
    },
  },
  viewSteps3Label: {
    fontSize            : "0.75rem",
    fontFamily          : '"Helvetica"',
    fontWeight          : "200",
    color               : "#303030",
    textAlign           : "center",
    "vertical-align"    : "middle",
  },
  viewSteps4Label: {
    fontSize            : "0.75rem",
    fontFamily          : '"Helvetica"',
    fontWeight          : "200",
    color               : "#303030",
    textAlign           : "center",
    "vertical-align"    : "middle",
  },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //---------------
  //PleaseWaitPopup
  //---------------
  pleaseWaitPopup: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    overflow         : "hidden",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
});

export default TransferOnline2Style;
